import { useTranslation } from 'libs/i18n'
import { useContext } from 'react'
import { useUserRoles } from 'shared/hooks'
import { StoreSettingsContext } from 'store'

export const useActionFilters = (isDisabled: boolean) => {
	const { t } = useTranslation()
	const { isStaff } = useUserRoles()
	const storeCtx = useContext(StoreSettingsContext)

	return [
		{
			id: 'actions',
			label: t('Actions'),
			placeholder: t('All'),
			options: [
				...(isStaff
					? [
							{
								value: 'print',
								label: t('Print'),
								isDisabled: isDisabled
							}
						]
					: []),

				{
					value: 'publish',
					label: t('Publish'),
					isDisabled: isDisabled
				},
				{
					value: 'unpublish',
					label: t('Unpublish'),
					isDisabled: isDisabled
				},
				...(isStaff
					? [
							{
								value: 'shopify',
								label: t('Sync with Shopify'),
								isDisabled: isDisabled
							}
						]
					: []),
				...(isStaff
					? [
							{
								value: 'regla',
								label: t('Sync with Regla'),
								isDisabled: isDisabled
							}
						]
					: []),
				{
					value: 'export',
					label: t('Export')
				},
				{
					value: 'delete',
					label: t('Delete'),
					isDisabled: isDisabled
				},
				...(storeCtx?.storeSettings?.product_confirm_enabled
					? [
							{
								value: 'confirm',
								label: t('Confirm'),
								isDisabled: isDisabled
							}
						]
					: []),
				...(storeCtx?.storeSettings?.product_confirm_enabled
					? [
							{
								value: 'unconfirm',
								label: t('Unconfirm'),
								isDisabled: isDisabled
							}
						]
					: [])
			]
		}
	]
}
